var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinicName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.008,
    viewBox: "0 0 12 13.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0071f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-medical-doctor_1_",
    "data-name": "icons8-medical-doctor (1)",
    className: "cls-1",
    d: "M7,0A4.659,4.659,0,0,0,4.922.359a1.443,1.443,0,0,0-.437.313,1,1,0,0,0-.156.266.558.558,0,0,0-.031.125L4.031,4.484v.078L4,4.906A.75.75,0,0,0,4,5a3,3,0,0,0,6,0V4.906L9.7,1.063A.562.562,0,0,0,9.672.938,1,1,0,0,0,9.516.672,1.444,1.444,0,0,0,9.078.359,4.659,4.659,0,0,0,7,0ZM7,8C3.7,8,1,9.553,1,10.953V13H13V10.953c0-1.33-2.441-2.8-5.516-2.937C7.322,8,7.162,8,7,8ZM7,1a3.832,3.832,0,0,1,1.625.25.3.3,0,0,1,.094.063l.2,2.563C8.461,3.9,7.836,4,7,4s-1.461-.1-1.922-.125l.2-2.563a.3.3,0,0,1,.094-.063A3.832,3.832,0,0,1,7,1Zm-.406.5v.594H6v.813h.594V3.5h.812V2.906H8V2.094H7.406V1.5ZM5.5,9.125,6.781,12H2V10.953C2,10.58,3.275,9.49,5.5,9.125Zm3,0c2.225.365,3.5,1.455,3.5,1.828V12H7.219Z",
    transform: "translate(-1 0.008)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicName);
export default __webpack_public_path__ + "static/media/clinicName.105f7085fbd4d978ed5f54b14936fdf7.svg";
export { ForwardRef as ReactComponent };